export const REDUCER_KEY = 'baskets';

/* export const TRANSACTIONS_OPEN = 'TRANSACTIONS_OPEN';
export const TRANSACTIONS_FINALIZED = 'TRANSACTIONS_FINALIZED';
export const ORDERS_OPEN = 'ORDERS_OPEN';
export const ORDERS_FINALIZED = 'ORDERS_FINALIZED';
export const NEGOTIATIONS_FINISHED = 'NEGOTIATIONS_FINISHED';
export const INACTIVE = 'INACTIVE';
 */
export const NEW = 'NEW';
export const NEGOTIATING_PROPOSALS = 'NEGOTIATING_PROPOSALS';
export const NEGOTIATING_PROPOSALS_FINALIZED =
  'NEGOTIATING_PROPOSALS_FINALIZED';
export const NEGOTIATING_ORDERS = 'NEGOTIATING_ORDERS';

//legacy - now CREATIVE_MATERIALS_EXCHANGE
//export const ORDERS_NEGOTIATIONS_FINALIZED = 'ORDERS_NEGOTIATIONS_FINALIZED';
export const CREATIVE_MATERIALS_EXCHANGE = 'CREATIVE_MATERIALS_EXCHANGE';
// new status NEGOTIATIONS_FNALIZED before IN_EMISSION
export const NEGOTIATIONS_FINALIZED = 'NEGOTIATIONS_FINALIZED';
export const IN_EMISSION = 'IN_EMISSION';
export const FINISHED = 'FINISHED';
export const SETTLED = 'SETTLED';
export const SUSPENDED = 'SUSPENDED';
export const DELETED = 'DELETED';

export const BASKET_STATUSES = [
  NEW,
  NEGOTIATING_PROPOSALS,
  NEGOTIATING_PROPOSALS_FINALIZED,
  NEGOTIATING_ORDERS,
  CREATIVE_MATERIALS_EXCHANGE,
  NEGOTIATIONS_FINALIZED,
  IN_EMISSION,
  FINISHED,
  SETTLED,
  SUSPENDED,
  DELETED,
];

export const BASKET_STATUSES_RENEGOTIATABLE = [
  CREATIVE_MATERIALS_EXCHANGE,
  NEGOTIATING_PROPOSALS_FINALIZED,
  NEGOTIATIONS_FINALIZED,
  IN_EMISSION,
  FINISHED,
  SETTLED,
];

export const BASKET_STATUSES_PROPOSALS_RENEGOTIATABLE = [
  NEGOTIATING_PROPOSALS,
  NEGOTIATING_PROPOSALS_FINALIZED,
];
